import {
  CLEAR_SINGLE_COMPO,
  DELETE_FAVICON_STATUS,
  DELETE_INCIDENTS_SOURCE,
  DELETE_INCIDENTS_STATUS,
  DELETE_LOGO_STATUS,
  GET_ALL_COMPO_GROUP,
  GET_ALL_INCIDENTS,
  GET_ALL_INCIDENTS_SOURCE,
  GET_ALL_INCIDENTS_STATUS,
  GET_ALL_MAINTAINANCE,
  GET_ALL_SERVICES,
  GET_ALL_SUBSCRIBER,
  GET_ALL_TEMPLATES,
  GET_PAGE_SETTINGS,
  GET_SINGLE_COMPO,
  GET_SINGLE_INCIDENTS,
  GET_SINGLE_MAINTAINANCE,
  GET_SINGLE_TEMPLATES,
  GET_STATUS_EMBED,
  GET_STATUS_GENERAL,
  UPLOAD_FAVICON_STATUS,
  UPLOAD_LOGO_STATUS,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ALL_INCIDENTS_SOURCE:
      return {
        ...state,
        IncidentsSourceList: action.payload,
      }

    case GET_ALL_INCIDENTS_STATUS:
      return {
        ...state,
        IncidentsStatusList: action.payload,
      }

    case GET_ALL_SUBSCRIBER:
      return {
        ...state,
        SubscriberList: action.payload,
      }

    case GET_ALL_SERVICES:
      return {
        ...state,
        ServicesList: action.payload,
      }
    case GET_ALL_COMPO_GROUP:
      return {
        ...state,
        CompoGroupList: action.payload,
      }
    case GET_SINGLE_COMPO:
      return {
        ...state,
        SingalCompo: action.payload,
      }
    case CLEAR_SINGLE_COMPO:
      return {
        ...state,
        SingalCompo: {},
      }
    case GET_ALL_TEMPLATES:
      return {
        ...state,
        TemplateList: action.payload,
      }
    case GET_SINGLE_TEMPLATES:
      return {
        ...state,
        SingalTemplate: action.payload,
      }

    case GET_STATUS_EMBED:
      return {
        ...state,
        GetStatusEmbed: action.payload,
      }

    case GET_STATUS_GENERAL:
      return {
        ...state,
        GetStatusGeneralData: action.payload,
      }

    case GET_ALL_INCIDENTS:
      return {
        ...state,
        GetIncidentsList: action.payload,
      }

    case GET_SINGLE_INCIDENTS:
      return {
        ...state,
        SingalIncidents: action.payload,
      }

    case GET_ALL_MAINTAINANCE:
      return {
        ...state,
        GetMaintainanceList: action.payload,
      }

    case GET_SINGLE_MAINTAINANCE:
      return {
        ...state,
        SingalMaintainance: action.payload,
      }

    case GET_PAGE_SETTINGS:
      return {
        ...state,
        GetPageSettingsData: action.payload,
      }

    case UPLOAD_LOGO_STATUS: {
      return {
        ...state,
        logo: action.payload,
      }
    }

    case DELETE_LOGO_STATUS: {
      return {
        ...state,
        logo: null,
      }
    }

    case UPLOAD_FAVICON_STATUS: {
      return {
        ...state,
        faviconLogo: action.payload,
      }
    }

    case DELETE_FAVICON_STATUS: {
      return {
        ...state,
        faviconLogo: null,
      }
    }

    case DELETE_INCIDENTS_SOURCE: {
      const {sourceId} = action.reduxData
      return {
        ...state,
        IncidentsSourceList: state.IncidentsSourceList?.filter(s => s.id !== sourceId),
      }
    }

    case DELETE_INCIDENTS_STATUS: {
      const {statusId} = action.reduxData
      return {
        ...state,
        IncidentsStatusList: state.IncidentsStatusList?.filter(s => s.id !== statusId),
      }
    }

    default:
      return state
  }
}
